<template>
  <div name="AddOrUpPage">
    
        <el-collapse v-model="collapseOpen"
            @change="changeCollapse"
        >
            <el-collapse-item v-for="(tabFieldSetOne,tabIndex) in pageSet.tabFieldSetList" :key="'addTab_'+tabIndex"
                :title="tabFieldSetOne.addBlockName" 
                :name="'addTab_'+tabIndex" 
            >
                <AddOrUpFieldTmp :ref="'addOrUpField'" 
                    :tmpfieldSet="tabFieldSetOne.fieldSet"
                    prevDateIndex=""
                    nowDateIndex=0
                    prevDataId=""
                    prevFieldId=0
                    :pageId="pageInfo.pageId+''"
                    :name_indexMap="tabFieldSetOne.name_indexMap"
                    :mainDataId="mainDataId+''"
                    dialogTableId="0"
                    :pageType="pageInfo.pageType+''"
                    :initData="initData"
                    :showHideJsList="pageSet.showHideJsList"
                    :customVueJs="pageSet.customVueJs" 
                    @zdyParentFun="zdyParentFun" 
                    @zdyValiadFun="zdyValiadFun" 
                    @getChildToHtData="getChildToHtData" 
                ></AddOrUpFieldTmp>
            </el-collapse-item>
            <!-- 审核流程信息 -->
            <el-collapse-item v-if="pageSet.ifAddCheckFlow == 1"
                title="审批流程" 
                name="addTab_checkFlow" 
            >
                <el-steps :active="checkFlowJson.dataNeedFloor-1" finish-status="success"  align-center>
                    <el-step v-for="(checkFlowOne,checkFlowIndex) in checkFlowJson.checkFlowList" :key="'checkFlow_'+checkFlowIndex"
                        :title="checkFlowOne.CHECK_USER" 
                        :icon="(checkFlowJson.dataNeedFloor==checkFlowOne.CHECK_FLOOR)?'el-icon-edit':''"
                    >
                        <div slot="description">
                            <el-form
                                label-width="100px" label-suffix=":"
                                :ref="checkFlowOne.needAdd?'checkFlowForm':''"
                                :model="checkFlowJson"
                                size="small"
                            >
                                <el-form-item
                                    label="审核状态"
                                    prop="saveCheckState"
                                    :rules="checkFlowOne.needAdd?[{
                                        required: true,
                                        message: '必须填写',
                                        trigger: ['change','blur']
                                    }]:[]"
                                >

                                    <el-select v-if="checkFlowOne.needAdd"
                                        v-model="checkFlowJson.saveCheckState" 
                                        class="add_or_up_input"
                                    >
                                        <el-option
                                            v-for="dicItem in checkFlowState"
                                            :key="dicItem.DIC_ID"
                                            :label="dicItem.DIC_NAME"
                                            :value="dicItem.DIC_ID"
                                            :disabled="dicItem.disabled">
                                        </el-option>
                                    </el-select>
                                    <span v-else>
                                        {{checkFlowOne.CHECK_STATE}}
                                    </span>
                                </el-form-item>
                                <el-form-item
                                    label="审核时间"
                                    prop="saveCheckState"
                                >
                                    {{checkFlowOne.CHECK_TIME}}
                                </el-form-item>
                                <el-form-item
                                    label="审核备注"
                                    prop="saveCheckRemark"
                                    :rules="checkFlowOne.needAdd?[{
                                        required: true,
                                        message: '必须填写',
                                        trigger: ['change','blur']
                                    }]:[]"
                                >
                                    <el-input v-if="checkFlowOne.needAdd"
                                        v-model="checkFlowJson.saveCheckRemark" 
                                        type="textarea"
                                    >
                                    </el-input>
                                    <span v-else>
                                        {{checkFlowOne.CHECK_REMARK}}
                                    </span>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-step>
                </el-steps>
            </el-collapse-item>
        </el-collapse>

        
        <el-tabs v-if="pageSet.tabPageSet && pageSet.tabPageSet.length > 0" type="border-card">
            <el-tab-pane v-for="(tabPageOne,tabPageIndex) in pageSet.tabPageSet" :key="'pageTab_'+tabPageIndex"
                :label="tabPageOne.tabName"
            >
                <!-- 根据页面类型进行页面加载  如果类型为1则为列表页面-->
                <ListPage v-if="tabPageOne.type == 1"
                    :ref="'listPage_'+tabPageOne.pageId" :initPageInfo="tabPageOne" :mainId="pageInfo.initMainDataId" 
                    :sourcePageInfo="pageInfo"
                >
                </ListPage>

                <AddOrUpPage v-if="tabPageOne.type != 1"
                    ref="addOrTab" :initPageInfo="tabPageOne" 
                ></AddOrUpPage>

            </el-tab-pane>
        </el-tabs> 


    
  </div>
</template>

<script>

import AddOrUpFieldTmp  from '@/components/page/AddOrUpFieldTmp.vue';

export default {
  name: 'AddOrUpPage',
  components:{AddOrUpFieldTmp},
  props: {
    /**
     * 页面信息
     * pageId：页面id
     * tableId:对象id
     * pageType:页面类型
     * initMainDataId:传入的数据主键id  当前是修改页面(有可能是修改的数据的Id,也有可能是关联的id) 如果是添加页面(则有可能是关联主键id,也有可能是)
     * mainTableId:列表tableId
     */
    initPageInfo: {
        type:Object,
        default:null
    }
  },
  data(){
      return {
          pageInfo:{},
          /**
           * 添加修改需要保存到后台的数据
           */
          addOrUpData:{
          },
          /**
           * form表单验证的对象
           */
          formRules:{

          },
          /**
           * 页面设置的信息
           */
          pageSet:{
              tabFieldSetList:[]
          },
          /**
           * 修改页面的初始化的 数据信息
           */
          initData:null,
          /**
           * 默认选中第一个选项卡
           */
          collapseOpen: ['addTab_0'],
          /**
           * 审核流程信息
           */
          checkFlowJson:{
              checkFlowList:[],
              saveCheckState:null,
              saveCheckRemark:null
          },
          /**
           * 固定审核状态值
           */
          checkFlowState:[{
                DIC_ID : 1,
                DIC_NAME : '审核通过'
            },{
                DIC_ID : 2,
                DIC_NAME : '审核不通过'
            }
            /*,{
                DIC_ID : 3,
                DIC_NAME : '驳回'
            },{
                DIC_ID : 4,
                DIC_NAME : '待审核'
            },{
                DIC_ID : 5,
                DIC_NAME : '审核中'
            }*/
            ]
      }
  },
  methods:{
    /**
     * 检查form表单 验证是否通过
     */
    checkFormRules:function(){
        
        
        //判断是否有分块加载 如果有 则循环块 如果没有则直接获取子页面的form表单校验结果
        var that = this;
        var resultCheckArr = this.getCheckFormArr();
        //检查是否有关联选项卡  如果有 则需要关联选项卡也完成填写后才能保存主页面
        var addOrTabArr = this.$refs.addOrTab;
        if(addOrTabArr) {
            addOrTabArr.forEach(element => {
                element.getCheckFormArr();
                var oneTabChildArr = element.tmpResultCheckArr;
                oneTabChildArr.forEach(childOne => {
                    resultCheckArr.push(childOne);
                });
            });
        }
        //判断是否有审核 有的话进行审核的验证判断
        console.log("that.$refs=================",that.$refs);
        if(that.$refs['checkFlowForm']) {
            var resultOne = that.$refs['checkFlowForm'][0].validate();
            resultCheckArr.push(resultOne);
        }
        console.log("进入表单验证===================",resultCheckArr);
        Promise.all(resultCheckArr).then(function() { //都通过了
            console.log('恭喜你，表单全部验证通过啦')
            if(typeof(that["zdySaveBeforeAjax"]) == "function") {
                that["zdySaveBeforeAjax"](that);
            } else {
                that.toHtSaveDate();
            }
        }).catch(function() {
            console.log("验证之后的catch,不知道干什么的");
        });
    },
    /**
     * 获取需要验证的关联选项卡的信息
     */
    getCheckFormArr:function(){
        var that = this;
        var addOrUpFieldRefs = this.$refs.addOrUpField;
        var resultCheckArr=[];
        for (let index = 0; index < addOrUpFieldRefs.length; index++) {
            const element = addOrUpFieldRefs[index];
            element.checkFormRules();
            var childResultCheckArr = element.resultCheckArr;
            childResultCheckArr.forEach(childOne => {
                resultCheckArr.push(childOne);
            });
        }
        this.tmpResultCheckArr = resultCheckArr;
        return resultCheckArr;
    },
    
    /**
     * 去后台保存数据
     */
    toHtSaveDate:function() {
        var url = "";
        var that = this;
        if(typeof(that["zdySaveBefore"]) == "function") {
            that["zdySaveBefore"](that);
        }
        var pageType = that.pageInfo.pageType;
        var pageId = that.pageInfo.pageId;
        var pageSet = that.pageSet;
        var flag = true;
        if(flag) {
            that.$emit("disableListSaveButton",true);
            //根据页面类型获取不同的请求地址
            var pageId = that.pageInfo.pageId;
            var tableId = that.pageInfo.tableId;
            var mainDataId = that.mainDataId;
            var toHtData = {};
            toHtData.tableId = tableId;
            toHtData.pageId = pageId;
            //是否走触发器
            toHtData.ifTrigger = pageSet.ifTrigger;
            //触发器执行顺序 triggerOrder
            toHtData.triggerOrder = pageSet.triggerOrder;

            //列表的tableId和pageId 从按钮中获得 mainTableId  mainPageId 
            toHtData.mainTableId = that.pageInfo.mainTableId;
            toHtData.mainPageId = that.pageInfo.mainPageId;

            if(pageType == 5) {
                //如果是添加按钮点击
                url = "/add_addInfo.do";
                if(this.pageSet.tableType == 10) {
                    url = "/mongoAdd_addInfo.do";
                }
                //关联添加
                if(mainDataId > 0) {
                    var dialogIdName = pageSet.dialogIdName;
                    toHtData["t0_"+dialogIdName] = mainDataId;    
                }
            } else if(pageType == 7) {
                url = "/update_updateInfo.do";
                if(this.pageSet.tableType == 10) {
                    url = "/mongoUpdate_updateInfo.do";
                }
                toHtData["t0_au_"+tableId+"_"+pageId] = mainDataId;
            } else if(pageType == 8) {
                url = "/batchUpdate_updateInfo.do";
                if(this.pageSet.tableType == 10) {
                    url = "/mongoBatchUpdate_updateInfo.do";
                }
                toHtData["t0_au_"+tableId+"_"+pageId] = mainDataId;
            }

            //循环子组件 分别进行子组件的需要传递到后台的数据获取
            var childToHtData = that.getChildToHtData();
            for(var key in childToHtData){
                toHtData[key] = childToHtData[key];
            }

            //获取审核信息的内容传递至后台 进行审核保存
            console.log("checkFlowJson===========1111=============",this.checkFlowJson);
            if(this.checkFlowJson.nodeId > 0) {
                //本次审核节点的节点ID
                toHtData.checkFlowNodeId = this.checkFlowJson.nodeId;
                //本次审核的 审核状态
                toHtData.checkFlowState = this.checkFlowJson.saveCheckState;
                //本次审核的 审核备注信息
                toHtData.checkFlowRemark = this.checkFlowJson.saveCheckRemark;
                //审核的对象的tableName 和 主键名称
                toHtData.tableName = this.pageSet.tableName;
                toHtData.mainFieldName = this.pageSet.mainFieldName;
            }
            
            //进行后台数据保存
            that.$axios.post(url,toHtData).then(res => {
                //如果返回的是ID 则表示保存成功  如果不是则表示失败
                if(res.data*1>0) {
                    
                    that.$message({
                        message: '恭喜你，数据保存成功',
                        type: 'success'
                    });

                    //检查是否有关联选项卡  如果有 则需要关联选项卡也完成填写后才能保存主页面
                    var addOrTabArr = this.$refs.addOrTab;
                    if(addOrTabArr) {
                        addOrTabArr.forEach(element => {
                            element.toHtSaveDate();
                        });
                    }
                    if(typeof(that["zdySaveSuccess"]) == "function") {
                        that["zdySaveSuccess"](that,res.data);
                    }
                    that.$emit("disableListSaveButton",false);
                    that.$emit("cancelListDialog");
                    that.$emit("initSearchData");
                } else {
                    that.$message.error('保存出现错误！错误原因为:'+res.data);
                    that.$emit("disableListSaveButton",false);
                }
            }).catch(error => {
                console.log("=====" + error);
                that.$emit("disableListSaveButton",false);
            })
        }
    },
    /**
     * 获取子组件的需要后台保存的信息
     */
    getChildToHtData:function(){
        var that = this;
        var addOrUpFieldRefs = that.$refs.addOrUpField;
        var toHtData = {};
        var flag = true;
        for (let index = 0; index < addOrUpFieldRefs.length; index++) {
            const element = addOrUpFieldRefs[index];
            element.getToHtData(0);
            var oneData = element.tmpToHtData;
            console.log("oneData============",oneData);
            
            for(var key in oneData){
                toHtData[key] = oneData[key];
            }
        }
        this.allToHtData = toHtData;
        return toHtData;
    },
    /**
     * 传递到子页面的方法信息
     */
    zdyParentFun:function(json) {
        //调用列表(父级)页面的方法
        this.$emit("zdyParentFun",json);
    },
    /**
     * 传递到子页面的方法信息
     */
    zdyValiadFun:function(json) {
        //调用列表(父级)页面的方法
        this.$emit("zdyValiadFun",json);
    },
    /**
     * 切换折叠面板 不允许切换
     */
    changeCollapse:function(activeNames){
        //打开全部面板
        var tmpJson = JSON.stringify(this.initCollapseOpen);
        this.collapseOpen = JSON.parse(tmpJson);
    }
  },
  /**
   * 页面创建时 判断是否是路由跳转
   */
  created:function(){
    var that = this;
    //请求地址传递的参数
    var paramsJson = this.$route.query;
    console.log("paramsJson=================",this.$route);
    if(that.initPageInfo) {
        that.pageInfo = that.initPageInfo;
    } else {
        //判断是否有初始的试题显示类型 如果有则赋值给showType
        if(paramsJson.tableId) {
            that.pageInfo.tableId = paramsJson.tableId;
        }
        if(paramsJson.pageId) {
            that.pageInfo.pageId = paramsJson.pageId;
        }
        if(paramsJson.pageType) {
            that.pageInfo.pageType = paramsJson.pageType;
        }
        if(paramsJson.initMainDataId) {
            that.pageInfo.initMainDataId = paramsJson.initMainDataId;
        }
        if(paramsJson.mainTableId) {
            that.pageInfo.mainTableId = paramsJson.mainTableId;
        }
        if(paramsJson.mainPageId) {
            that.pageInfo.mainPageId = paramsJson.mainPageId;
        }
    }
  },
  
  /**
   * 页面创建时 进行后台数据请求 请求页面设置信息 之后再做浏览器端缓存
   */
  beforeMount : function(){
    var that = this;
   
    var pageId = this.pageInfo.pageId;
    var tableId = this.pageInfo.tableId;
    var pageType = this.pageInfo.pageType;
    //当前数据ID
    var initMainDataId = this.pageInfo.initMainDataId;
    that.mainDataId = initMainDataId;
    //列表的tableId
    var mainTableId = this.pageInfo.mainTableId;
    var url = "/wxXcxSet_interfaceToAdd.do";
    this.loading = true;
    this.$axios.post(url,{
        pageId: pageId,
        tableId: tableId,
        pageType:pageType,
        mainId: initMainDataId,
        mainTableId:mainTableId
    }).then(res => {
        that.loading = false;
        if (res.data) {
            
            var addOrUpData = {};
            var tmpPageSet = that.pageSet;
            var tmpCollapseOpen = that.collapseOpen;
            //列表页面操作按钮的数据信息
            tmpPageSet.tabFieldSetList = res.data.pageSet.tabFieldSetList;
            tmpPageSet.dialogIdName = res.data.pageSet.dialogIdName;

            //进行修改页面的数据加载
            if((pageType == 7 || pageType == 11) && res.data.initUpdateData) {
                that.initData = res.data.initUpdateData;
                that.initData.ifUpdate = true;
                //判断是否需要修改
                if(initMainDataId != res.data.initUpdateData["T_"+tableId+"_0"]) {
                    that.mainDataId = res.data.initUpdateData["T_"+tableId+"_0"];
                }
            }
            if(pageType == 5 && res.data.initGlAddData) {
                that.initData = res.data.initGlAddData;
                //判断是否需要修改mainDataId
                that.initData.ifUpdate = true;
            }

            if(tmpPageSet.tabFieldSetList == null || tmpPageSet.tabFieldSetList == undefined) {
                tmpPageSet.tabFieldSetList = [];
            }
            if(res.data.pageSet.fieldSet) {
                tmpPageSet.tabFieldSetList.push({
                    'fieldSet':res.data.pageSet.fieldSet,
                    'addBlockName':'全部信息',
                    'name_indexMap':res.data.pageSet.name_indexMap
                });
            }
            //tmpPageSet.fieldSet = res.data.pageSet.fieldSet;
            //tmpPageSet.name_indexMap = res.data.pageSet.name_indexMap;

            //是否支持审批流程 ifAddCheckFlow
            tmpPageSet.ifAddCheckFlow =  res.data.pageSet.ifAddCheckFlow;
            //进行层级数据合并 判断是否有当前登录人需要审核 如果有则显示为需要审核
            if(res.data.checkFlowList) {
                var checkFlowJson = {};
                var checkFlowList = [];
                //获取登陆人的主键 
                var loginInfo = JSON.parse(sessionStorage.loginInfo);
                console.log("loginInfo============================",loginInfo);
                
                var loginUserId = loginInfo.USERID;
                res.data.checkFlowList.forEach(element => {
                    //当前数据的需要的审核层级
                    var dataNeedFloor = element.NEED_FLOOR;
                    checkFlowJson.dataNeedFloor = dataNeedFloor;
                    //判断是否是新的层级 是新的层级进行checkFlowList层级追加
                    var nowCheckFloor = element.CHECK_FLOOR;
                    var floorJson = {
                        needAdd:false,
                        CHECK_USER:'',
                        CHECK_STATE:'',
                        CHECK_TIME:'',
                        CHECK_FLOOR:nowCheckFloor,
                        REMARK:''
                    };
                    if(nowCheckFloor > checkFlowList.length) {
                        checkFlowList.push(floorJson);
                    } else {
                        floorJson = checkFlowList[nowCheckFloor-1];
                    }
                    //审核人名称
                    var checkUser = element.CHECK_USER;
                    floorJson.CHECK_USER += (floorJson.CHECK_USER != ""?",":"")+checkUser;
                    //审核人ID
                    var checkUserId = element.CHECK_USERID;
                    //审批流程池节点 主键
                    var nodeId = element.NODE_ID;
                    //审核状态 CHECK_STATE  
                    var checkState = element.CHECK_STATE;
                    var checkStateName = "待审核";
                    that.checkFlowState.forEach(dicOne => {
                        if(dicOne.DIC_ID == checkState) {
                            checkStateName = dicOne.DIC_NAME;
                        }
                    });
                    floorJson.CHECK_STATE += (floorJson.CHECK_STATE != ""?",":"")+checkStateName;

                    //审核日期 CHECK_TIME
                    var checkTime = element.CHECK_TIME;
                    floorJson.CHECK_TIME += (floorJson.CHECK_TIME != ""?",":"")+(checkTime?checkTime:"");
                    //审核备注 REMARK
                    var checkRemark = element.REMARK;
                    floorJson.REMARK += (floorJson.REMARK != ""?",":"")+(checkRemark?checkRemark:"");
                    //如果审核人ID=登陆人 当前审核层级=本层 则需要进行审核
                    console.log("loginUserId===",loginUserId,checkUserId,nowCheckFloor,dataNeedFloor);
                    
                    if(loginUserId == checkUserId && (nowCheckFloor == dataNeedFloor || nowCheckFloor == (dataNeedFloor-1))) {
                        floorJson.needAdd = true;
                        checkFlowJson.nodeId = nodeId;
                        if(nowCheckFloor == (dataNeedFloor-1)) {
                            checkFlowJson.saveCheckState = checkState;
                            checkFlowJson.saveCheckRemark = checkRemark;
                        }
                    }

                });
                checkFlowJson.checkFlowList = checkFlowList;
                that.checkFlowJson = checkFlowJson;
                console.log("checkFlowJson===================",checkFlowJson);
                
            }


            if(tmpPageSet.tabFieldSetList != null && tmpPageSet.tabFieldSetList.length > 1) {
                for(var tmpI = 1;tmpI < tmpPageSet.tabFieldSetList.length; tmpI++){
                    tmpCollapseOpen.push('addTab_'+tmpI);
                }
            }
            //判断是否支持审批流程 如果支持 增加审核流程的选项卡打开
            if(tmpPageSet.ifAddCheckFlow == 1) {
                tmpCollapseOpen.push('addTab_checkFlow');
            }
            //判断是否有关联的选项卡设置 tabPageSet
            tmpPageSet.tabPageSet = res.data.pageSet.tabPageSet;
            if(tmpPageSet.tabPageSet && tmpPageSet.tabPageSet.length > 0) {
                tmpPageSet.tabPageSet.forEach(element => {
                    element.tableId = element.relationObjId;
                    element.pageId = element.pageId;
                    element.pageType = element.type;
                    if(element.type != 1) {
                        element.initMainDataId = that.pageInfo.initMainDataId;
                        element.mainTableId = that.pageInfo.mainTableId;
                    }
                    element.sourcePageInfo = {
                        tableId:that.pageInfo.mainTableId,
                        pageId:that.pageInfo.mainPageId
                    }
                });
            }

            
            //获取自动生成的 切换隐藏显示的js方法
            var showHideJsList = res.data.pageSet.showHideJsList;
            tmpPageSet.showHideJsList = showHideJsList;
            
            //对象类型 使之支持monogodb类型
            tmpPageSet.tableType = res.data.pageSet.tableType;
            
            //触发器是否走
            tmpPageSet.ifTrigger =  res.data.pageSet.ifTrigger;
            //触发器执行顺序 triggerOrder
            tmpPageSet.triggerOrder =  res.data.pageSet.triggerOrder;

            //对象的表名
            tmpPageSet.tableName =  res.data.pageSet.tableName;
            //对象的主键名称
            tmpPageSet.mainFieldName =  res.data.pageSet.mainFieldName;
            
            //自定义customVueJs
            tmpPageSet.customVueJs = res.data.pageSet.customVueJs;

            that.addOrUpData = addOrUpData;
            that.collapseOpen = tmpCollapseOpen;
            that.initCollapseOpen = tmpCollapseOpen;
            that.pageSet = tmpPageSet;
            eval(that.pageSet.customVueJs);
        } else{
            //登陆失败
            this.$message({
                showClose: true,
                message: '页面信息获取失败了，请重试!',
                type: 'error'
            });
        }
    }).catch(error => {
        console.log("=====" + error);
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
